import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'MTBF (Mean Time Between Failures)',
  slug: 'mtbf',
  definition: `MTBF measures the average elapsed time between one failure and the next. It includes both the operating time (MTTF) and the repair time (MTTR), giving a complete picture of how frequently a system experiences failures.

The formula is simple: MTBF = MTTF + MTTR. A service with an MTTF of 30 days and an MTTR of 2 hours has an MTBF of roughly 30 days and 2 hours. In practice, the MTTF component dominates for well-run services.

MTBF is widely used in reliability engineering to compare systems and track improvements. A rising MTBF over time means your system is becoming more reliable.`,
  whyItMatters: `MTBF gives you a single number to describe overall system reliability. It accounts for both how often things break and how long they stay broken, making it more useful than MTTF or MTTR alone.

For SLA planning, MTBF helps you predict future downtime. If your MTBF is 15 days and your MTTR is 30 minutes, you can estimate roughly two incidents per month, each lasting about 30 minutes — that is 1 hour of downtime, or 99.86% uptime.`,
  howUptrackHelps: `Uptrack automatically tracks incidents and their resolution times, providing the raw data needed to calculate MTBF for each of your services. You can monitor trends over weeks and months.

With precise 30-second detection, the timestamps Uptrack records are accurate, giving you trustworthy MTBF calculations rather than approximations based on slow check intervals.`,
  formula: 'MTBF = MTTF + MTTR',
  relatedTerms: [
    { name: 'MTTF', href: '/glossary/mttf' },
    { name: 'MTTR', href: '/glossary/mttr' },
    { name: 'MTTD', href: '/glossary/mttd' },
    { name: 'SLA', href: '/glossary/sla' },
    { name: 'MTBF guide: meaning, formula, examples', href: '/blog/what-is-mtbf-meaning-formula' },
  ],
}

export const Route = createFileRoute('/_site/glossary/mtbf')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
